import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Hook to go back to previous history record safely.
 *
 * @description Go back to the previous page in history.
 *   If no history exist then go one directory up.
 */
export const useGoBackSafe = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const goBackSafe = () => {
		if (navigate.length > 1) {
			navigate(-1);
		} else {
			const currentPath = location?.pathname ?? '';
			// remove the last directory from the path '/<any-non-space-character>
			const parentPath = currentPath.replace(/(?:\/[^\s\/]*)$/, '');

			navigate(parentPath ?? '/');
		}
	};

	return { goBackSafe };
};
